var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-layout',{attrs:{"justify-center":""}},[_c('v-progress-circular',{attrs:{"size":70,"width":7,"color":"green","indeterminate":""},model:{value:(_vm.loading),callback:function ($$v) {_vm.loading=$$v},expression:"loading"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }